import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';

export default function RiskAssessments() {
  const navigate = useNavigate();
  return (
    <Layout>
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Risk Assessments</h1>
        <div className="bg-white rounded-lg shadow p-6"><p>Risk assessment interface coming soon...</p></div>
      </div>
    </Layout>
  );
}
